export enum BlendingSrcFactorName {
  SrcAlphaSaturateFactor = 'SrcAlphaSaturateFactor'
}
